import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    fromDate: String,
    toDate: String,
    facility: String,
    member: String,
    category: String,
    orAnd: String,
    memberString: String,
    facilityString: String,
    city: String,
    county: String,
    region: String
  }
  static targets = ["facilities", "categories", "members", "fromDate", "toDate", "dateOption", "downloadButton", "city", "county", "region", "memberString", "facilityString"];

  initialize() {
    super.initialize();
    this.globalFilters = {
      from_date: this.fromDateValue,
      to_date: this.fromDateValue,
      facility_ids: [this.facilityValue].filter(val => val),
      member_ids: [this.memberValue].filter(val => val),
      categories: [this.categoryValue].filter(val => val),
      or_and: this.orAndValue,
      member_string: this.memberStringValue,
      facility_string: this.facilityStringValue,
      city: this.cityValue,
      county: this.countyValue,
      region: this.regionValue,
    };
  }

  handleOnChangeDateRange(event) {
    if('custom' === event.target.value) {
      $('#global-custom-date-range').show();
      this.globalFilters['from_date'] = $('#global_filter_from_date').attr('value');
      this.globalFilters['to_date'] = $('#global_filter_to_date').attr('value');
      this.reloadAllFrames();
    } else {
      $('#global-custom-date-range').hide();
      this.handleFilterChange("date", event.target.value);
    }
    this.setAndOrFilter();
  }

  handleOnChangeIndividualDateRange(event) {
    this.handleFilterChange(event.target.name, event.target.value);
  }

  handleOnChangeFacility(event) {
    this.handleFilterChange("facility_ids", [event.target.value]);
  }

  handleOnChangeCategory(event) {
    this.handleFilterChange("categories", [event.target.value]);
  }

  handleOnChangeMember(event) {
    if (this.hasFacilitiesTarget) {
      return;
    }
    const value = event.target.value;
    this.handleFilterChange("member_ids", [value]);
    const memberFilter = $('.members-filters-list');
    const andOrFilter = $('.and_or_filters');
    if (value) {
      const memberNames = Array.from(this.membersTarget.selectedOptions, option => option.label).join(",").trim();
      const title = `Members = ${memberNames}`;
      this.addFilterPill(andOrFilter, memberFilter, title);
      console.warn('memberFilter', memberFilter)
    } else {
      if (this.dateOptionTarget.value === 'all_time') {
        this.removeElement(andOrFilter);
      }
      this.removeElement(memberFilter);
    }
  }

  handleOnChangeToggle() {
    let or_and_value = $('.slider-value').is(':checked') === true ? 'AND' : 'OR';
    this.handleFilterChange("or_and", or_and_value);
  }

  handleFilterChange(category, values) {
    if(category === 'date') {
      this.globalFilters['from_date'] = values;
      this.globalFilters['to_date'] = values;
    } else {
      this.globalFilters[category] = Array.isArray(values) ? values.filter(val => val) : values;
    }
    this.reloadAllFrames();
    if (category !== 'member_ids') {
      this.setAndOrFilter();
    }
  }

  anyBadgeVisible() {
    const selectors = [
      '.members-filters-list',
      '.categories-filters-list',
      '.facilities-filters-list',
      '.city-filters-list',
      '.county-filters-list',
      '.region-filters-list',
      '.member-string-filters-list',
      '.facility-string-filters-list',
      '.date-range-filters-list'
    ];
    return selectors.some(sel => $(sel).hasClass('d-flex'));
  }

  handleOnChangeCity(event) {
    const value       = event.target.value;
    const andOrFilter = $('.and_or_filters');
    const cityBadge   = $('.city-filters-list');

    this.handleFilterChange("city", value);

    if (value) {
      this.addFilterPill(andOrFilter, cityBadge, `City = ${value}`);
    } else {
      this.removeFilterPill(cityBadge);

      if (!this.anyBadgeVisible()) {
        this.removeElement(andOrFilter);
      }
    }
  }

  handleOnChangeCounty(event) {
    const value       = event.target.value;
    const andOrFilter = $('.and_or_filters');
    const badge       = $('.county-filters-list');

    this.handleFilterChange("county", value);

    if (value) {
      this.addFilterPill(andOrFilter, badge, `County = ${value}`);
    } else {
      this.removeFilterPill(badge);
      if (!this.anyBadgeVisible()) {
        this.removeElement(andOrFilter);
      }
    }
  }

  handleOnChangeRegion(event) {
    const value       = event.target.value;
    const andOrFilter = $('.and_or_filters');
    const badge       = $('.region-filters-list');

    this.handleFilterChange("region", value);

    if (value) {
      this.addFilterPill(andOrFilter, badge, `Region = ${value}`);
    } else {
      this.removeFilterPill(badge);
      if (!this.anyBadgeVisible()) {
        this.removeElement(andOrFilter);
      }
    }
  }

  handleOnChangeMemberString(event) {
    const value       = event.target.value;
    const andOrFilter = $('.and_or_filters');
    const badge       = $('.member-string-filters-list');

    this.handleFilterChange("member_string", value);

    if (value) {
      this.addFilterPill(andOrFilter, badge, `Member contains = ${value}`);
    } else {
      this.removeFilterPill(badge);
      if (!this.anyBadgeVisible()) {
        this.removeElement(andOrFilter);
      }
    }
  }

  handleOnChangeFacilityString(event) {
    const value       = event.target.value;
    const andOrFilter = $('.and_or_filters');
    const badge       = $('.facility-string-filters-list');

    this.handleFilterChange("facility_string", value);

    if (value) {
      this.addFilterPill(andOrFilter, badge, `Facility contains = ${value}`);
    } else {
      this.removeFilterPill(badge);
      if (!this.anyBadgeVisible()) {
        this.removeElement(andOrFilter);
      }
    }
  }

  reloadAllFrames() {
    this.reloadDownloadButton()
    $("turbo-frame[id*='_metric_preview']").each((_, frame) => this.reloadFrame(frame));
    $("turbo-frame[id*='_metric_data_visualization']").each((_, frame) => this.reloadFrame(frame));
    $("turbo-frame[id*='_metric_table']").each((_, frame) => this.reloadFrame(frame));
  }

  prepareNewUrl(oldUrl) {
    const url = new URL(oldUrl);
    const globalFilters = {}
    for (const [key, value] of Object.entries(this.globalFilters)) {
      globalFilters[key] = this.parseValue(value);
    }
    url.search = $.param({ 'q_global': globalFilters });
    return url.toString();
  }

  parseValue(value) {
    if(value.isArray) {
       return encodeURIComponent(JSON.stringify(value))
    }
    return value;
  }

  reloadDownloadButton() {
    if (!this.hasDownloadButtonTarget)
      return;

    var oldDownloadUrl = this.downloadButtonTarget.getAttribute('href');
    var newDownloadUrl = this.prepareNewUrl(oldDownloadUrl);
    this.downloadButtonTarget.setAttribute('href', newDownloadUrl);
  }

  reloadFrame(frame) {
    const url = this.prepareNewUrl(frame.src);
    const jQueryFrame = $(frame);
    jQueryFrame.attr("src", url);
  }

  setAndOrFilter(){
    if (!this.hasFromDateTarget || !this.hasToDateTarget) return;
    const facilityNames = this.hasFacilitiesTarget ? Array.from(this.facilitiesTarget.selectedOptions, option => option.label).join(",").trim() : '';
    const categoriesNames = this.hasCategoriesTarget ? Array.from(this.categoriesTarget.selectedOptions, option => option.label).join(",").trim() : '';
    const fromDate = this.formatDate(this.fromDateTarget.value);
    const toDate = this.formatDate(this.toDateTarget.value);
    const dateOption = this.dateOptionTarget.value;

    const filter = $('.and_or_filters');
    const dateRange = $('#q_global_date_option');
    if (this.allFiltersSelected(categoriesNames, facilityNames, dateOption)){
      this.showElement(filter);
      this.showElement($('.and_or_toggle'));
      const categoriesPill = $('.categories-filters-list');
      const facilitiesPill = $('.facilities-filters-list');
      this.showElement(categoriesPill);
      this.showElement(facilitiesPill);
      categoriesPill.text(`Categories = ${categoriesNames}`);
      facilitiesPill.text(`Facilities = ${facilityNames}`);
      const dateText = dateOption === 'custom' ? `Date Range = ${fromDate} - ${toDate}` : `Date Range = ${this.mapDateRange(dateOption)}`;
      $('.date-range-filters-list').text(dateText);
    }
    else if (this.noFilterSelected(categoriesNames, facilityNames, dateOption)) {
      this.removeElement(filter);
    }
    else {
      if (categoriesNames.length > 0)
        this.addFilterPill(filter, $('.categories-filters-list'), `Categories = ${categoriesNames}`);
      else
        this.removeFilterPill($('.categories-filters-list'));

      if (facilityNames.length > 0)
        this.addFilterPill(filter, $('.facilities-filters-list'), `Facilities = ${facilityNames}`);
      else
        this.removeFilterPill($('.facilities-filters-list'));

      if (dateOption !== 'all_time') {
        if (dateOption === 'custom')
          this.addFilterPill(filter, $('.date-range-filters-list'), `Date Range = ${fromDate} - ${toDate}`);
        else
          this.addFilterPill(filter, $('.date-range-filters-list'), `Date Range = ${this.mapDateRange(dateOption)}`);
      } else {
        this.removeFilterPill($('.date-range-filters-list'));
      }
    }
  }

  allFiltersSelected(categories, facilities, dateOption){
    return categories.length > 0 && facilities.length > 0 && dateOption !== 'all_time'
  }

  noFilterSelected(categories, facilities, dateOption) {
    if (this.hasMembersTarget) {
      return this.membersTarget.selectedOptions.length === 0 && dateOption === 'all_time'
    }
    return categories.length === 0 && facilities.length === 0 && dateOption === 'all_time'
  }

  addFilterPill(filter, element, pillText) {
    this.showElement(filter);
    this.showElement(element);
    element.text(pillText);
  }

  removeFilterPill(element) {
    this.removeElement(element);
    this.removeElement($('.and_or_toggle'));
  }

  removeElement(element){
    element.removeClass('d-flex');
    element.addClass('d-none');
  }

  showElement(element){
    element.removeClass('d-none');
    element.addClass('d-flex');
  }

  formatDate(value){
    return value.substring(0, 10).replace(/-/g, "/");
  }

  mapDateRange(str) {
    switch (str) {
      case '7_days_ago':
        return 'This Week';
      case '30_days_ago':
        return 'This Month';
      case '90_days_ago':
        return 'Last 90 Days';
      default:
        return str;
    }
  }
}
